<template>
  <el-upload
    class="avatar-uploader"
    name="file"
    :action="baseUrl"
    :on-error="upError"
    :show-file-list="false"
    :headers="header"
    :on-success="handleAvatarSuccess"
    :before-upload="beforeAvatarUpload"
    accept="image/*"
  >
    <img v-if="value" :src="value" class="avatar" />
    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
  </el-upload>
</template>

<script>
import utils from "@/jslibs/utils";
export default {
  props: ["imgLink", "groupId", "value"],
  data() {
    return {
      updata: {
        source: 50,
      },
      imgBase: "https://train-service-cdn.oss-cn-shenzhen.aliyuncs.com/",
      baseUrl: process.env.VUE_APP_BASE_API + "/v1/common/UploadFile",
      header: {
        "X-Access-Token": utils.getCookie("X-Access-Token") || "",
      },
      imageUrl: this.imgLink || "",
    };
  },
  watch: {
    imgLink: function (newVal, oldVal) {
      this.imageUrl = newVal;
    },
  },
  mounted() {},

  methods: {
    upError() {
      this.$emit("endUpload");
      this.$message.error("上传失败");
    },
    handleAvatarSuccess(res, file) {
      if (!res) {
        this.$message.warning("格式错误");
        return false;
      }
      console.log(res);

      this.imageUrl = this.imgBase + res.result; // 服务器返回的图片地址

      // this.imageUrl = URL.createObjectURL(file.raw);//本地图片地址
      this.$emit("input", this.imageUrl);
      this.$emit("imgUrl", this.imageUrl);
    },
    beforeAvatarUpload(file) {
      if (["image/gif", "image/jpeg", "image/jpg", "image/png", "image/svg"].indexOf(file.type) == -1) {
        this.$message.warning("请上传正确格式的图片");
        return false;
      }

      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false;
      }
      this.$emit("startUpload");
    },
  },
};
</script>

<style scoped="scoped">
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  background-color: #f5f5f5;
  text-align: center;
}
.avatar {
  width: 178px;
  /* height: 178px; */
  display: block;
}
</style>
